export const NAV_EXPERIMENT = 'nav-experiment';
export const DESKTOP_MI = 'desktop-menu-open';
export const MOBILE_MI = 'mobile-menu-open';
export const NAV_EXP_PARAMS_PROP = 'nav-categories';
